import { Avatar } from "@mui/material"
import React from "react"

export const GenericAvatar = (props) => {
  const {
    size = '32px',
    location = '',
    backgroundColor = 'primary.main',
    avatarId = 1
  } = props;

  return (
    <Avatar
      sx={{
        height: size,
        width: size,
        backgroundColor: backgroundColor
      }}
      src={!location ? `https://www.gravatar.com/avatar/${avatarId}?&s=256&d=identicon` : location}
    />
  )
}